var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicantGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ccc;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25,33.32c-.19,0-.37-.04-.54-.13L4.13,22.5c-.38-.2-.62-.6-.62-1.03s.24-.83.62-1.03l20.33-10.69c.34-.18.74-.18,1.08,0l20.33,10.69c.38.2.62.6.62,1.03s-.24.83-.62,1.03l-20.33,10.69c-.17.09-.35.13-.54.13ZM7.16,21.48l17.84,9.38,17.84-9.38-17.84-9.38L7.16,21.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25,38.23c-2.04,0-4.07-.46-5.97-1.39l-3.68-1.8c-.4-.19-.65-.6-.65-1.04v-6.38c0-.64.52-1.16,1.16-1.16s1.16.52,1.16,1.16v5.66l3.03,1.48c3.15,1.54,6.76,1.54,9.9,0l3.03-1.48v-5.63c0-.64.52-1.16,1.16-1.16s1.16.52,1.16,1.16v6.36c0,.44-.25.85-.65,1.04l-3.68,1.8c-1.9.93-3.93,1.39-5.97,1.39Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.57,37.44c-.64,0-1.16-.52-1.16-1.16v-10l-11.92-5.85c-.57-.28-.81-.98-.53-1.55.28-.57.98-.81,1.55-.53l12.57,6.17c.4.19.65.6.65,1.04v10.72c0,.64-.52,1.16-1.16,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.23,20.95c-.86-.42-1.22-1.47-.8-2.33s1.47-1.22,2.33-.8c.86.42,1.22,1.47.8,2.33-.42.86-1.47,1.22-2.33.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.57 40.37 35.22 34.61 37.57 35.97 39.93 34.61 37.57 40.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantGray);
export default __webpack_public_path__ + "static/media/applicant_gray.f74b1104928679d5165d3d528125ae08.svg";
export { ForwardRef as ReactComponent };